module.exports = __webpack_public_path__ + "img/multi-step-quiz-v3.5cb94369.svg";